import Controller from "csi/action/Controller";
import PostRequest from "csi/comm/PostRequest";
import MessageDialog from "csi/widget/MessageDialog";
import html from "csi/html";
import locale from "csi/locale";
import declare from "dojo/_base/declare";
import JsonResponse from "csi/comm/JsonResponse";

const ImportCanvasTemplatesController = declare(Controller, {
	/** @property {boolean} bInterrupt - set to true so that controller is stopped on next action when user cancels file browser */
	bInterrupt: true,

	/** @property {File[]} fileList - list of files uploaded */
	fileList: null,

	/**
	 * @override
	 * Select files to upload.
	 */
	onPreActionDeferreds(dfds: PromiseLike<void | File[]>[]): void {
		dfds.push(html.selectFiles(".zip")
			.then((files) => {
				this.fileList = files;
			}));
	},

	/**
	 * @override
	 * Import the canvas templates.
	 */
	process(): void {
		const req = new PostRequest("SiteAdmin", "ImportCanvasTemplates")
			.addFiles(this.fileList, null, "FormFileFieldName");
		this.waitForPublish(req.post(), true);
	},

	/**
	 * @override
	 * Get list of attribute keys that may have errors. If none, then import was successful.
	 */
	_onPublishResponse(response: JsonResponse): void {
		const listOfTemplatesWithMissingKeys: string[] = response.getReturnValue();
		if (listOfTemplatesWithMissingKeys.length) {
			let message = `\n${this.getString("_AttributeKeysMissing")}:\n`;
			listOfTemplatesWithMissingKeys.forEach((entry: string) => {
				const { fileName, templateName, keySet } = JSON.parse(entry);
				message += `\n${locale.resource("Template")} ${templateName} ${locale.resource("SearchIn")} ${fileName}:`;
				message += `\n${keySet.join("\n")}\n`;
			});
			this.displayErrorDialog({
				materialIcon: MessageDialog.ICON_WARNING,
				message,
				onResponse: () => {
					this.inherited(arguments);
				},
				title: this.getString("_ImportFailedTitle"),
			});
		} else {
			this.inherited(arguments);
		}
	},
});

export = ImportCanvasTemplatesController;